import { Product } from '@/core/entity';
import {
  ProductInput,
  IProductGateway,
  PresenterFunc,
  UpdaterFunc,
} from '@/core/interface';
import { Fragment } from '@/core/interface/common';

export class ProductService {
  constructor(
    private readonly productGateway: IProductGateway,
  ) { }

  public async createProduct(
    input: ProductInput,
    presenter: PresenterFunc<Product | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const result = await this.productGateway.createProduct(input, fragment, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }

  public async updateProduct(
    id: string,
    input: ProductInput,
    presenter: PresenterFunc<Product | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const result = await this.productGateway.updateProduct(id, input, fragment, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
